<template>
    <div>
        <b-row>
            <b-col class="d-flex justify-content-between align-items-center">
                <text-header id="atmo-proposals" class="atmo-hash-jump-point">Предложения участников закупочной сессии</text-header>
            </b-col>
        </b-row>
        <template v-if="purchase.status.id === 'accepting'">
            <p v-if="purchase.is_hidden">Период скрытия предложений участников в закупочной сессии наступил {{ $formatDateTimeIn(purchase.hide_proposals_at) }}</p>
            <p v-else>Предложения участников будут скрыты {{ $formatDateTimeIn(purchase.hide_proposals_at) }}</p>
        </template>
        <text-row-datetime v-if="purchase.protocol_date" label="Дата и время формирования итогового протокола" v-model="purchase.protocol_date" :label-cols-lg="4" compact />
        <b-table v-if="!(purchase.status.id === 'accepting' && purchase.is_hidden)" :fields="fields" :items="purchase.proposals" class="table-atmo" show-empty small responsive>
            <template #cell(index)="data">
                {{ data.index + 1 }}
            </template>
            <template #cell(status)="data">
                {{ data.item.status.title }} <span v-if="data.item.is_my_proposal" v-text="'(Моё)'" />
            </template>
            <template #cell(created_at)="data">
                {{ $formatDateTime(data.item.created_at) }}
            </template>
            <template #cell(supplier)="data">
                <router-link v-if="isPurchaseSummarized || hasContract || purchase.flags.has_final_protocol" class="atmo-button-link" target="_blank" v-bind:to="{ name: 'OrganizationShow', params: { id: data.item.supplier.id } }">{{ data.item.supplier.name }}</router-link>
                <span v-else v-text="`Поставщик ${data.index + 1}`" />
            </template>
            <template #cell(documents)="data">
                <ul v-if="data.item.documents.length > 0">
                    <li v-if="data.item.commercial_proposal">
                        <a class="fs-14 col-form-label atmo-button-link d-inline-block pb-0" :href="$getAttachmentDownloadLink(data.item.commercial_proposal.id)" target="_blank">{{ data.item.commercial_proposal.name }}</a>
                    </li>
                    <li v-for="document of data.item.documents" :key="document.id">
                        <a class="fs-14 col-form-label atmo-button-link d-inline-block pb-0" :href="$getAttachmentDownloadLink(document.id)" target="_blank">{{ document.name }}</a>
                    </li>
                </ul>
                <p class="fs-14 grey-color my-auto col-form-label" v-else>Отсутствуют</p>
            </template>
            <template #cell(actions)="data">
                <signature-xml-info-button
                    title="Электронная подпись к предложению"
                    :supplier-signature="data.item.signature"
                    size="sm"
                    :allow-download-xml="purchase.flags.is_participant && purchase.supplier_proposal.id === data.item.id" />
            </template>
            <template #empty>
                <div class="w-100 text-center">Нет поданных предложений</div>
            </template>
        </b-table>
    </div>
</template>

<script>
export default {
    name: 'fl44-unknown-volume-proposals-block',
    props: {
        purchase: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            signData: {
                signature: null,
                isCustomer: false
            },
            baseFields: [
                { key: 'index', label: '№', tdClass: 'align-text-top text-nowrap py-1', thClass: 'py-1', thStyle: { width: '1px' } },
                { key: 'status', label: 'Статус', tdClass: 'align-text-top py-1', thClass: 'text-nowrap py-1' },
                { key: 'created_at', label: 'Дата и время подачи', tdClass: 'align-text-top py-1 text-nowrap', thClass: 'py-1' },
                { key: 'supplier', label: 'Поставщик', tdClass: 'align-text-top py-1', thClass: 'py-1' },
            ],
        };
    },
    computed: {
        isPurchaseSummarized() {
            return this.purchase.status.id === 'summarized' || this.purchase.status.id === 'contract:active' || this.purchase.status.id === 'contract:field';
        },
        hasContract() {
            return !!this.purchase.contract;
        },
        fields() {
            const result = this.baseFields;
            if ((this.purchase.is_customer && this.isPurchaseSummarized || this.hasContract)) {
                result.push({ key: 'documents', label: 'Документы', tdClass: 'align-text-top py-1 text-nowrap', thClass: 'py-1' });
            }
            if (this.isPurchaseSummarized || this.hasContract) {
                result.push({ key: 'actions', label: 'Подпись', tdClass: 'align-text-top py-1 text-nowrap text-right', thClass: 'py-1 text-nowrap text-right', thStyle: { width: '1px' } });
            }
            return result;
        }
    }
};
</script>
